import axios from "axios";

const BASE = "https://us-central1-inprojuy-f1173.cloudfunctions.net/app";

export const adminApi = {
  // Roles
  getRoles: () => axios.get(`${BASE}/api/admin/roles`),
  crearRol: (data) => axios.post(`${BASE}/api/admin/roles`, data),
  editarRol: (id, data) => axios.put(`${BASE}/api/admin/roles/${id}`, data),
  eliminarRol: (id) => axios.delete(`${BASE}/api/admin/roles/${id}`),

  // Permisos
  getPermisosCatalogo: () => axios.get(`${BASE}/api/admin/permisos-catalogo`),

  // Usuarios
  getUsuarios: () => axios.get(`${BASE}/users`),
  cambiarRolUsuario: (userId, newRole) =>
    axios.post(`${BASE}/users/${userId}/role`, { newRole }),
  cambiarCasinoUsuario: (userId, casinoId) =>
    axios.post(`${BASE}/users/${userId}/casino`, { casinoId }),

  // Notificaciones
  getNotificaciones: () => axios.get(`${BASE}/api/admin/notificaciones-config`),
  actualizarNotificacion: (tipo, destinatarios) =>
    axios.put(`${BASE}/api/admin/notificaciones-config/${tipo}`, { destinatarios }),

  // Audit log
  getAuditLog: (limit = 50, startAfter) =>
    axios.get(`${BASE}/api/admin/audit-log`, { params: { limit, startAfter } }),

  // Casinos
  getCasinos: (params) => axios.get(`${BASE}/api/admin/casinos`, { params }),
  crearCasino: (data) => axios.post(`${BASE}/api/admin/casinos`, data),
  editarCasino: (id, data) => axios.put(`${BASE}/api/admin/casinos/${id}`, data),
  desactivarCasino: (id) => axios.delete(`${BASE}/api/admin/casinos/${id}`),
  reactivarCasino: (id) => axios.post(`${BASE}/api/admin/casinos/${id}/reactivar`),

  // Consultas autoexcluidos (auditoría)
  getConsultasAutoexcluidos: (params) =>
    axios.get(`${BASE}/api/admin/consultas-autoexcluidos`, { params }),
  getStatsConsultasAutoexcluidos: (params) =>
    axios.get(`${BASE}/api/admin/consultas-autoexcluidos/stats`, { params }),

  // Descargas (ABM)
  getDescargas: () => axios.get(`${BASE}/api/admin/descargas`),
  crearDescarga: (data) => axios.post(`${BASE}/api/admin/descargas`, data),
  editarDescarga: (id, data) => axios.put(`${BASE}/api/admin/descargas/${id}`, data),
  desactivarDescarga: (id, borrarArchivo = false) =>
    axios.delete(`${BASE}/api/admin/descargas/${id}`, { params: { borrarArchivo } }),
  reactivarDescarga: (id) => axios.post(`${BASE}/api/admin/descargas/${id}/reactivar`),
};
